module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalEmpleadosConDocumentos) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._v("¿SEGURO QUE DESEA CONTINUAR?")])]), _c('div', {
    staticClass: "card-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.mensajeRespuesta))]), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.listaEmpleadosRespuesta), function(nombre, index) {
    return _c('li', {
      key: index,
      staticClass: "tal"
    }, [_c('span', [_vm._v(_vm._s(nombre))])])
  }), 0)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.validarModalEmpleadoForzar()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Continuar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.cerrarModalEmpleadosForzar()
      }
    }
  }, [_vm._v("Cancelar")])])])]) : _vm._e()]), (_vm.mostrarConfirmacionModal) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionModal = false
      },
      "do": _vm.validarConfirmacion
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Está seguro de " + _vm._s(_vm.tipoConfirmacion.descripcion) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSaving) ? [_vm._v("Guardando...")] : [_vm._v("Guardar")]], 2)])], 1) : _vm._e(), _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._t("title", [_vm._v("Seleccione los empleados")])], 2), _c('div', {
    staticClass: "contenedor-acciones"
  }, [_c('div', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        return _vm.abrirModalConfirmacion('asignarTodos')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Asignar Todos")])]), _c('div', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        return _vm.abrirModalConfirmacion('desasignarTodos')
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Desasignar Todos")])])])]), _c('div', {
    staticClass: "contenedor-interno"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaArea) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-area', {
    on: {
      "selected": _vm.seleccionarArea,
      "close": function($event) {
        _vm.mostrarBusquedaArea = false
      }
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar empleados..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }, _vm.fetchSearch]
    }
  })]), (_vm.empresa !== 'raymisa') ? _c('div', {
    staticClass: "control pt-5"
  }, [_c('div', {
    staticClass: "input-container"
  }, [(!_vm.area.idArea) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.area.idArea),
      expression: "area.idArea"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading,
      "placeholder": "Buscar Area",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.area.idArea)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.area, "idArea", $event.target.value)
      }
    }
  }) : _c('div', {
    staticClass: "item fdc flex-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.area.nombreArea)))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.area.nombreGerencia))])]), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarArea
    }
  }, [_vm._m(2)])])]) : _vm._e()]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredEmpleados), function(employee, index) {
    return _c('div', {
      key: 'alumno_lookup_' + employee.codigo,
      staticClass: "usuario",
      class: {
        'selected': employee.nuevoSeleccionado || employee.seleccionado
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelection(employee)
        }
      }
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('span', {
      staticClass: "codigo"
    }, [_vm._v(_vm._s(employee.dni) + ":")]), _c('span', {
      staticClass: "nombre"
    }, [_vm._v(" " + _vm._s(employee.nombre))])])])
  }), 0), (!_vm.isLoading & _vm.filteredEmpleados.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron empleados activos")])]) : _vm._e()], 1)], 1), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.asignarEmpleados(false)
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67914582","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lookups/Empleados_Multiple.vue
// module id = 894
// module chunks = 0